import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import rotateImage from '../image-rotation';

@Component({
    selector: 'app-image-slider',
    templateUrl: './image-slider.component.html',
    styleUrls: ['./image-slider.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageSliderComponent implements OnInit {
	@Input() images: any;
	@Input() position: number;
	@Input() userId: string;
	@Input() editable: boolean;
	@Input() showEditButton: boolean = false;
	@Input() type: string;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	view: string = '';
	loading: boolean;

	next() {
		if (this.position + 1 == this.images.length) {
			this.position = 0
		} else {
			this.position++
		}
		this.removeRotated();
	}
	previous() {
		if (this.position == 0) {
			this.position = this.images.length - 1
		} else {
			this.position--
		}
		this.removeRotated();
	}

	loadImage() {

	}

	removeRotated() {
		this.images.map(i => {
			i.wasRotated = false;
			i.base64 = null;
		});
	}

	rotate(image: HTMLImageElement) {
		const img = new Image();
		this.renderer.setAttribute(img, 'crossOrigin', '*');
		img.onload = () => {
			let dataUrl = rotateImage(img);
			image.src = dataUrl;
			this.images[this.position].wasRotated = true;
			this.images[this.position].base64 = dataUrl;
		};
		this.renderer.setAttribute(img, 'src', image.src);
	}

	close() {
		this.closeView.emit()
	}
	delete() {
		this.view = 'delete'
	}
	save() {
		this.view = 'save'
	}
	deleteConfirm() {
		this.notify.emit({ position: this.position, type: "delete" })
	}
	saveConfirm() {
		this.view = '';
		this.notify.emit({ position: this.position, type: "save" })
	}
	edit() {
		this.notify.emit({ position: this.position, type: "edit" })
	}

	constructor(
		public _gS: GlobalService,
		private renderer: Renderer2) { }

	ngOnInit() {
		console.log(this.position);
		console.log(this.images[this.position]);
	}
}
